<template>
  <div id="dispatch-note-container">
    <div id="dispatch-note-internal-container">
      <h5 class="dispatch-note-title">
        <font-awesome-icon
          icon="hotel"
          style="margin-right: 4px; margin-bottom:1px; color: #006adb"
        />Eταιρεία παραλαβής
      </h5>

      <div id="dispatch-note-info-container">
        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">ΑΦΜ:</h6>
          <input class="dispatch-note-input" v-model="vat" @input="clearErrors()" type="text" />

          <button id="search-company-button" @click="searchCompanyByVat()">
            <clip-loader v-if="ongoingAction" :loading="ongoingAction" size="10px" color="#ffffff" />
            <font-awesome-icon v-else icon="search" />
          </button>
        </div>
        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Επωνυμία:</h6>
          <input
            class="dispatch-note-input"
            v-model="companyName"
            @input="clearErrors()"
            type="text"
          />
        </div>
        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Διεύθυνση:</h6>
          <input class="dispatch-note-input" v-model="address" @input="clearErrors()" type="text" />
        </div>
        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Πόλη:</h6>
          <input class="dispatch-note-input" v-model="city" @input="clearErrors()" type="text" />
        </div>
        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Τ.Κ:</h6>
          <input
            class="dispatch-note-input"
            v-model="postalCode"
            @input="clearErrors()"
            type="text"
          />
        </div>

        <h6 id="dispatch-note-error-msg">{{errorMessage}}</h6>

        <hr style="margin-top:6px; margin-bottom:8px" />

        <h5 class="dispatch-note-title">
          <font-awesome-icon
            icon="receipt"
            style="margin-right: 4px; margin-bottom:1px; color: #198b4a"
          />Στοιχεία δελτίου αποστολής
        </h5>
        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Ημερομηνία αποστολής:</h6>
          <date-picker
            @change="clearErrors()"
            @pick="clearErrors()"
            @close="clearErrors()"
            @open="clearErrors()"
            id="dispatch-date-pick"
            type="datetime"
            v-model="dispatchDateTime"
            :time-picker-options="timePickerOptions"
            :disabled-date="disabledBeforeToday"
            time-title-format="DD MMM YYYY"
            format="ddd DD MMM | HH:mm"
            placeholder="Επιλέξτε ημερομηνία και ώρα"
            :show-second="false"
          ></date-picker>
        </div>

        <div
          class="dispatch-note-input-container"
          style="margin-top:10px; align-items: center !important;"
        >
          <h6 class="dispatch-note-header">Σκοπός:</h6>
          <select
            v-model="movePurpose"
            @change="clearErrors()"
            class="dispatch-note-select dispatch-note-header"
          >
            <option :value="null" disabled>Επιλέξτε</option>
            <option :value="1">Πώληση</option>
            <option :value="2">Πώληση για Λογαριασμό Τρίτων</option>
            <option :value="3">Δειγματισμός</option>
            <option :value="4">Έκθεση</option>
            <option :value="5">Επιστροφή</option>
            <!-- <option :value="6">Φύλαξη</option> -->
            <option :value="7">Επεξεργασία Συναρμολόγηση</option>
            <!-- <option :value="8">Μεταξύ Εγκαταστάσεων Οντότητας</option> -->
            <option :value="9">Αγορά</option>
            <option :value="10">Εφοδιασμός πλοίων και αεροσκαφών</option>
            <option :value="11">Δωρεάν διάθεση</option>
            <option :value="12">Εγγύηση</option>
            <option :value="13">Χρησιδανεισμός</option>
            <option :value="14">Αποθήκευση σε Τρίτους</option>
            <!-- <option :value="15">Επιστροφή από Φύλαξη</option> -->
            <!-- <option :value="16">Ανακύκλωση</option> -->
            <!-- <option :value="17">Καταστροφή άχρηστου υλικού</option> -->
            <!-- <option :value="18">Διακίνηση Παγίων (Ενδοδιακίνηση)</option> -->

            <!--Below is allowed but i should send along other_move_purpose_title, TODO when selected show one more input-->
            <!-- <option :value="19">Λοιπές Διακινήσεις</option> -->
          </select>
        </div>

        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Πόλη παραλαβής:</h6>
          <input
            class="dispatch-note-input"
            v-model="pickupCity"
            @input="clearErrors()"
            type="text"
          />
        </div>

        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Διεύθυνση παραλαβής:</h6>
          <input
            class="dispatch-note-input"
            v-model="pickupAddress"
            @input="clearErrors()"
            type="text"
          />
        </div>

        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">ΤΚ διεύθυνσης παραλαβής:</h6>
          <input
            class="dispatch-note-input"
            v-model="pickupPostalCode"
            @input="clearErrors()"
            type="text"
          />
        </div>

        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Πόλη προορισμού:</h6>
          <input
            class="dispatch-note-input"
            v-model="deliveryCity"
            @input="clearErrors()"
            type="text"
          />
        </div>

        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">Διεύθυνση προορισμού:</h6>
          <input
            class="dispatch-note-input"
            v-model="deliveryAddress"
            @input="clearErrors()"
            type="text"
          />
        </div>

        <div class="dispatch-note-input-container">
          <h6 class="dispatch-note-header">ΤΚ διεύθυνσης προορισμού:</h6>
          <input
            class="dispatch-note-input"
            v-model="deliveryPostalCode"
            @input="clearErrors()"
            type="text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StoreApi from "../api/stores";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: "DispatchNoteInfo",

  props: ["restaurantId", "selectedTable"],
  components: {
    ClipLoader,
    DatePicker
  },
  data() {
    return {
      ongoingAction: false,
      error: false,
      errorMessage: "",
      vat: null,
      companyName: null,
      address: null,
      city: null,
      postalCode: null,
      dispatchDateTime: null,
      movePurpose: null,
      pickupCity: null,
      pickupAddress: null,
      pickupPostalCode: null,
      deliveryCity: null,
      deliveryAddress: null,
      deliveryPostalCode: null
    }
  },
  watch: {

  },
  computed: {
    language() {
      return this.$store.getters.getLanguage;
    },
    authToken() {
      return this.$store.getters.getUserAuthToken;
    },
    jwt() {
      return this.$store.getters.getUserJWT;
    },
    timePickerOptions() {
      return {
        start: '00:00',
        step: `00:05`,
        end: '23:59',
        format: 'HH:mm'
      };
    }
  },
  methods: {
    async searchCompanyByVat() {
      if (!this.ongoingAction) {
        this.error = false;
        this.errorMessage = '';
        this.companyName = null;
        this.address = null
        this.city = null;
        this.postalCode = null;

        if (this.vat == null || this.vat.trim().length < 9) {
          this.error = true;
          this.errorMessage = 'Συμπληρώστε τον 9ψήφιο ΑΦΜ'
          try {
            document.getElementById('dispatch-note-error-msg').scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
          } catch (error) {
            console.log("Could not scroll to receipt error msg")
          }
          return;
        }

        this.ongoingAction = true;
        let response = await StoreApi.fetchCompanyByVat(this.restaurantId, this.vat, this.authToken, this.jwt);
        if (response.error) {
          this.ongoingAction = false;
          this.error = true;
          this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.'
        } else {
          this.ongoingAction = false;
          if (response.searchResults != null && response.searchResults.length > 0) {
            let companyDetails = response.searchResults.find(searchResult => !searchResult.isBranch);
            if (companyDetails == null) {
              this.error = true;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.';
              return;
            }
            this.companyName = companyDetails.coNameEl;
            this.address = companyDetails.streetNumber != null ? companyDetails.street + " " + companyDetails.streetNumber : companyDetails.street;
            this.city = companyDetails.city;
            this.postalCode = companyDetails.zipCode;
          } else {
            this.error = true;
            this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.'
          }
        }
      }
    },

    disabledBeforeToday(date) {
      let firstDateForScheduledOrders = new Date();
      firstDateForScheduledOrders.setHours(0, 0, 0, 0);
      return date < firstDateForScheduledOrders || date > new Date(firstDateForScheduledOrders.getTime() + (this.scheduledOrdersDaysRange - 1) * 24 * 3600 * 1000);
    },

    setErrorMsg(errorMessage) {
      this.error = true;
      this.errorMessage = errorMessage;
    },

    clearErrors() {
      this.error = false;
      this.errorMessage = "";
    },

    getDispatchNoteInfo() {
      let dispatchNoteInfo = {
        vat: this.vat,
        companyName: this.companyName,
        address: this.address,
        city: this.city,
        postalCode: this.postalCode,
        dispatchDateTime: this.dispatchDateTime,
        movePurpose: this.movePurpose,
        pickupCity: this.pickupCity,
        pickupAddress: this.pickupAddress,
        pickupPostalCode: this.pickupPostalCode,
        deliveryCity: this.deliveryCity,
        deliveryAddress: this.deliveryAddress,
        deliveryPostalCode: this.deliveryPostalCode
      };
      return dispatchNoteInfo;
    },

    resetState() {
      this.error = false;
      this.errorMessage = "";
      this.vat = null;
      this.companyName = null;
      this.address = null;
      this.city = null;
      this.postalCode = null;
    }

  },
  mounted() {

  }
};
</script>

<style scoped>
#dispatch-note-container {
  width: 90%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 7.5px 0 7.5px 0;
  color: black;
}

.smaller-margins {
  margin-bottom: 0px !important;
  padding: 2px 0 1px 0 !important;
}

.dispatch-note-title {
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
}

#dispatch-note-internal-container {
  display: flex;
  flex-direction: column;
}

.dispatch-note-input-container {
  width: 95%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-shrink: 0;
  color: black;
  margin-bottom: 0px !important;
  margin-top: 0px;
  padding: 2px 0 1px 0 !important;
}

.dispatch-note-header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

.dispatch-note-input {
  margin-left: 4px;
  background-color: #ffffff;
  width: 100%;
  padding-left: 5px;
  padding-bottom: 1px;

  border-radius: 5px;
  margin-bottom: 5px;
  border: 1px solid #c0c0c0;
}

.dispatch-note-select {
  margin-left: 10px;
  border: 1px solid #c0c0c0;
  padding-left: 6px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 8px;
  width: 100%;
}

#dispatch-date-pick {
  width: 100%;
  border: 1px solid #c0c0c0;
  border-radius: 8px;
}

#search-company-button {
  padding: 4px 6px 4px 6px;
  border-radius: 6px;
  cursor: pointer;

  color: white;
  background-color: #006adb;
  font-size: 10px;
  font-weight: 600;
  margin-top: 0px !important;
  margin-left: 6px;
  margin-bottom: 5px;
}

#dispatch-note-error-msg {
  font-size: 13px;
  font-weight: 600;
  color: #ee0800;
  margin-bottom: 0px;
}

@media screen and (max-width: 1397px) {
  .dispatch-note-header {
    font-size: 12px;
    font-weight: 600;
  }

  .dispatch-note-input {
    font-size: 12px;
  }
}
</style>